import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-drop-down-horas-minutos',
  templateUrl: './drop-down-horas-minutos.component.html',
  styleUrls: ['./drop-down-horas-minutos.component.css']
})
export class DropDownHorasMinutosComponent implements OnInit {

  horas = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  minutos = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  @Output() tiempoSeleccionadoEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Input() tiempoSeleccionado:string;

  horaSeleccionada:string = null;
  minutoSeleccionado:string = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges){
    if(changes['tiempoSeleccionado']?.currentValue){
      let tiempoArray = this.tiempoSeleccionado.split(':');
      this.horaSeleccionada = tiempoArray[0];
      this.minutoSeleccionado = tiempoArray[1];
    }
  }

  ngOnInit(): void {
  }

  getHoras(horas:any){ //vendrá como string, ponemos "any" ya que el dato viene de un union de string y DesplegableData
    this.horaSeleccionada = horas;
    if(this.horaSeleccionada && this.minutoSeleccionado){
      this.tiempoSeleccionadoEmitter.emit(`${this.horaSeleccionada}:${this.minutoSeleccionado}`)
    }
  }

  getMinutos(minutos:any){ //vendrá como string
    this.minutoSeleccionado = minutos;
    if(this.horaSeleccionada && this.minutoSeleccionado){
      this.tiempoSeleccionadoEmitter.emit(`${this.horaSeleccionada}:${this.minutoSeleccionado}`)
    }
  }


}
